import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const faqs = [
  {
    q: "Is Veristamp a legal service?",
    a: "No — Veristamp provides evidence-integrity technology. It does not provide legal advice or notarization services.",
  },
  {
    q: "What does tamper-evident mean?",
    a: "Every photo is fingerprinted with SHA-256 the instant it's taken. A fingerprint is a unique code computed from the image's exact pixels — change even one pixel and the code no longer matches. That means any alteration after capture is detectable.",
  },
  {
    q: "Do both parties need the app?",
    a: "No — countersigning happens through a secure email link in any browser. Co-tenants, landlords, and managers each receive their own single-use link. No app or account required.",
  },
  {
    q: "Does it work without internet?",
    a: "Yes. Veristamp is offline-first — empty rentals often have no signal, so full capture works with zero connectivity. Photos are fingerprinted and timestamped at the moment of capture, not when they sync later.",
  },
  {
    q: "What happens to my photos?",
    a: "Faces and documents are detected and blurred on your device before anything uploads. Photos are stored encrypted, media links are signed and expire, and you can delete your account and data anytime. No ads. No data selling. Ever.",
  },
  {
    q: "Which regions have compliance guidance?",
    a: "California guidance is live today — designed to support AB 2801 photo requirements, including a deposit-cap checker and a 21-day return-deadline tracker. Capture and certified reports work everywhere; guidance for more states and countries is coming soon.",
  },
  {
    q: "How much does it cost?",
    a: "Capturing is free and unlimited. A certified report is $11.99 — you pay only when you need the document. Landlord Pro is $19.99/year and adds deduction statements, deadline tracking, and compliance tooling.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-24 px-6 md:px-12">
    <div className="max-w-3xl mx-auto">
      <p className="text-[#8A6A00] text-xs font-semibold tracking-widest uppercase">Questions</p>
      <h2 className="mt-3 font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#14213D]">
        Frequently asked.
      </h2>
      <Accordion type="single" collapsible className="mt-10">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-[#2C3B5E]/20">
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="text-left font-heading font-bold text-[#14213D] hover:text-[#C9A227] hover:no-underline"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="text-sm text-[#5B6474] leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
